import axios from "axios";
import config from "@/config/constants.js";

export default {
  namespaced: true,
  state: {
    status: "",
    recommendations: [],
    coverage: null,
  },
  mutations: {
    loading(state) {
      state.status = "loading";
    },
    success(state) {
      state.status = "";
    },
    error(state) {
      state.status = "error";
    },
    setRecommendations(state, data) {
      state.recommendations = data;
    },
    setCoverage(state, data) {
      state.coverage = data;
    },
    updateRecommendationStatus(state, { id, status }) {
      const rec = state.recommendations.find(r => r.id === id);
      if (rec) rec.status = status;
    },
  },
  actions: {
    async fetchRecommendations({ commit }, statusFilter = 'pending') {
      commit('loading');
      try {
        const response = await axios.get(
          config.api_url + 'vendor/recommendations',
          {
            params: { status: statusFilter },
          }
        );
        if (response.data.code === 'SUCCESS') {
          commit('setRecommendations', response.data.data);
        }
        commit('success');
      } catch (error) {
        console.error('fetchRecommendations error:', error);
        commit('error');
      }
    },

    async approveRecommendation({ commit, dispatch }, id) {
      commit('loading');
      try {
        const response = await axios.put(
          config.api_url + 'vendor/recommendations/' + id + '/approve',
          {}
        );
        if (response.data.code === 'SUCCESS') {
          commit('updateRecommendationStatus', { id, status: 'approved' });
          dispatch('fetchCoverage');
        }
        commit('success');
        return response.data;
      } catch (error) {
        console.error('approveRecommendation error:', error);
        commit('error');
        return null;
      }
    },

    async declineRecommendation({ commit }, id) {
      commit('loading');
      try {
        const response = await axios.put(
          config.api_url + 'vendor/recommendations/' + id + '/decline',
          {}
        );
        if (response.data.code === 'SUCCESS') {
          commit('updateRecommendationStatus', { id, status: 'declined' });
        }
        commit('success');
        return response.data;
      } catch (error) {
        console.error('declineRecommendation error:', error);
        commit('error');
        return null;
      }
    },

    async fetchCoverage({ commit }) {
      try {
        const response = await axios.get(
          config.api_url + 'vendor/coverage'
        );
        if (response.data.code === 'SUCCESS') {
          commit('setCoverage', response.data.data);
        }
      } catch (error) {
        console.error('fetchCoverage error:', error);
      }
    },
  },
  getters: {
    pendingCount: state => state.recommendations.filter(r => r.status === 'pending').length,
    gapCount: state => {
      if (!state.coverage) return 0;
      return state.coverage.summary.gaps;
    },
  },
};
